<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import isEmpty from 'lodash/isEmpty';
  import { jobsFiltersStore } from '$lib/stores/Careers/jobFiltersStore';
  import { jobsByJobFunction } from '$lib/stores/Careers/jobsStore';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { ResponsiveVars, TwistBox, TwistStack } from '@twist/core';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  const dispatch = createEventDispatcher();

  const handleResetFilters = () => {
    jobsFiltersStore.reset();

    dispatch('filters-change', $jobsFiltersStore);
  };

  const responsiveVars = new ResponsiveVars()
    .addFluid('img-size', toFluidVarInput(312, 360))
    .addFluid('font-size', toFluidVarInput(20, 36))
    .toCSS();

  const brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

{#if isEmpty($jobsByJobFunction)}
  <div class={responsiveVars}>
    <TwistBox marginY={toFluidVarInput(75, 75)}>
      <TwistStack direction="column" justify="space-between" align="center">
        {#if !brandReskinEnabled}
          <img src="/images/careers/no-results.png" alt="No results" />
        {/if}
        <TwistBox marginTop={toFluidVarInput(21, 21)} marginBottom={toFluidVarInput(30, 30)}>
          <h4>No results</h4>
        </TwistBox>
        <BlockButton
          on:click={handleResetFilters}
          variant="fill"
          fontSize={toFluidVarInput(12, 16)}
          height={toFluidVarInput(30, 34)}
          py={toFluidVarInput(9, 9)}
          px={toFluidVarInput(15, 15)}
        >
          Reset filters
        </BlockButton>
      </TwistStack>
    </TwistBox>
  </div>
{/if}

<style>
  img {
    width: var(-img-size);
    height: var(-img-size);
    aspect-ratio: 1/1;
  }

  h4 {
    font-weight: 700;
    font-size: var(--font-size);
    line-height: 115%;
    font-family: var(--font-family-primary);
  }
</style>
